import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Axios from "middleware/axiosInstance";
import { Row, Col } from "antd";
import { Button, Form, Input, Checkbox } from "antd";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
import Loading from "layouts/Loading/Loading";

const AddAndEditSocialMedia = () => {
  // start react router url params
  const UrlParams = useParams();
  const { socialMediaId } = UrlParams;
  const isInEditMode = socialMediaId ? true : false;
  // end react router url params
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [socialMediaInfoForEdit, setSocialMediaInfoForEdit] = useState(null);

  const SubmitNewSocialMedia = async (socialMedia) => {
    // Set default value for is_visible if not provided
    if (socialMedia.is_visible === undefined) {
      socialMedia.is_visible = true;
    }

    Axios.post("/social-media", socialMedia)
      .then((res) => {
        navigate("/social-media");
        OpenNotificationWithIcon("ثبت موفق", "با موفقیت افزوده شد");
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (isInEditMode) {
      getSocialMediaInfoForEdit();
    }
  }, []);

  const getSocialMediaInfoForEdit = () => {
    Axios.get(`/social-media/${socialMediaId}`)
      .then((res) => {
        setSocialMediaInfoForEdit(res.data);
      })
      .catch((err) => console.log(err));
  };

  const socialMediaEditHandler = async (socialMedia) => {
    Axios.put(`/social-media/${socialMediaId}`, socialMedia)
      .then((res) => {
        navigate("/social-media");
        OpenNotificationWithIcon("ویرایش موفق", "با موفقیت ویرایش شد");
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">
          {isInEditMode ? "ویرایش شبکه اجتماعی" : "افزودن شبکه اجتماعی"}
        </h5>
        {isInEditMode && socialMediaInfoForEdit === null ? (
          <Loading />
        ) : (
          <Form
            layout="vertical"
            initialValues={{
              is_visible: true,
              ...(socialMediaInfoForEdit || {})
            }}
            form={form}
            autoComplete="off"
            scrollToFirstError
            labelCol={{ xs: 24 }}
            onFinish={isInEditMode ? socialMediaEditHandler : SubmitNewSocialMedia}
          >
            <Row gutter={8}>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  
                  label="نام"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "نام الزامی می باشد",
                    },
                  ]}
                >
                  <Input placeholder="اینستاگرام" readOnly/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={16} xl={18}>
                <Form.Item
                  label="آدرس"
                  name="address"
                  rules={[
                    {
                      type: "url",
                      message: "لطفا یک آدرس معتبر وارد کنید",
                    },
                  ]}
                >
                  <Input placeholder="https://instagram.com/yourpage" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  valuePropName="checked"
                  name="is_visible"
                  label="وضعیت نمایش در سایت "
                >
                  <Checkbox>نمایش داده شود</Checkbox>
                </Form.Item>
              </Col>

              <Col xs={24}>
                <Button htmlType="submit" type="primary">
                  {isInEditMode ? "ثبت تغییرات" : "افزودن"}
                </Button>
                <Button
                  className="me-3"
                  onClick={() => navigate("/social-media")}
                  style={{ marginRight: 8 }}
                >
                  بازگشت
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </div>
    </div>
  );
};
export default AddAndEditSocialMedia;

